export default __webpack_public_path__ + "static/media/NFT.cfdeb1c1.svg";